import { Button } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { getTranslation } from 'utils/getTranslation';

import { DonorStatusFilter, FILTER_CONFIG } from '../../constants';
import { IDonorTableRow } from '../../types';

const t = getTranslation('dashboard.DonorDashboard.DonorTable');
const tDashboard = getTranslation('dashboard.DonorDashboard');

export const getColumns = (
  onDonorClick: (donor: IDonorTableRow) => void
): ColumnsType<IDonorTableRow> => [
  {
    title: t('name'),
    dataIndex: 'name',
    key: 'name',
    render: (name: string, record) => (
      <Button
        type="link"
        onClick={() => onDonorClick(record)}
        style={{ padding: 0, fontWeight: 'bold' }}
      >
        {name}
      </Button>
    ),
  },
  {
    title: t('age'),
    dataIndex: 'age',
    key: 'age',
    render: (v: number) => t('years', { value: v }),
  },
  {
    title: t('gender'),
    dataIndex: 'gender',
    key: 'gender',
    render: (v: string) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase(),
  },
  {
    title: t('species'),
    dataIndex: 'species',
    key: 'species',
    render: (v: string) => v.charAt(0).toUpperCase() + v.slice(1).toLowerCase(),
  },
  {
    title: t('weight'),
    dataIndex: 'weight',
    key: 'weight',
    render: (v: number) => t('pounds', { value: v }),
  },
  {
    title: t('bloodType'),
    dataIndex: 'bloodType',
    key: 'bloodType',
    render: (v: string | null) => v ?? t('unknown'),
  },
  {
    title: t('approvedML'),
    dataIndex: 'approvedDonationML',
    key: 'approvedDonationML',
    render: (v: number) => t('milliliters', { value: v }),
  },
  {
    title: t('location'),
    dataIndex: 'location',
    key: 'location',
  },
  {
    title: t('status'),
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => {
      const config = FILTER_CONFIG[status as DonorStatusFilter];
      const color = config?.color ?? '#000000';
      const displayName = config ? tDashboard(config.translationKey) : status;

      return (
        <span
          style={{
            color,
            fontWeight: 'bold',
            padding: '2px 8px',
            borderRadius: '4px',
            backgroundColor: `${color}15`,
          }}
        >
          {displayName}
        </span>
      );
    },
  },
];
